function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "success-icon",
  transform: "translate(-534 -440)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_797",
  "data-name": "Grupo 797",
  transform: "translate(534 440)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_574",
  "data-name": "Grupo 574"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_873",
  "data-name": "Caminho 873",
  d: "M388.948,68.336a12,12,0,1,1,12-12A12.013,12.013,0,0,1,388.948,68.336Zm0-22.534a10.534,10.534,0,1,0,10.533,10.533A10.545,10.545,0,0,0,388.948,45.8Z",
  transform: "translate(-376.948 -44.336)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1018",
  "data-name": "Caminho 1018",
  d: "M107.375,54.952l-4.85-4.85.43-.43,4.4,4.4,8.215-9.116.452.407Z",
  transform: "translate(435.976 402.548)",
  strokeWidth: 0.8
}));

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.86d5497d.svg";
export { ForwardRef as ReactComponent };